<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
button.disabled {
  cursor: no-drop;
}
td button.btn.status {
  cursor: auto;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-xl-6 col-md-6 col-sm-12 d-flex">
        <div class="card bg-primary text-white flex-fill">
          <div class="row">
            <div class="col-md-9">
              <div class="card-body">
                <div class="mb-3">
                  <h3>{{ detailUser.nama_lengkap }}</h3>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mb-3">
              <i style="height: 40px; width: 40px; opacity: 0.8; float: right; margin-right: 13px;" class="c-sidebar-nav-icon fa fa-user opacity-7"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-md-6 col-sm-12 d-flex">
        <div class="card bg-primary text-white flex-fill">
          <div class="row">
            <div class="col-md-9">
              <div class="card-body">
                <div class="mb-3">
                  <h3>Sertifikasi {{ detailUser.nama_sertifikasi }}</h3>
                  <span class="font-weight-bold" style="font-size:20px">Periode {{ detailUser.periode }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mb-3">
              <i style="height: 40px; width: 40px; opacity: 0.8; float: right; margin-right: 13px;" class="c-sidebar-nav-icon fas fa-file-alt opacity-7"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <div class="card-header bg-primary font-weight-bold text-white d-flex align-items-center">
        Mata Uji Sertifikasi {{ detailUser.nama_sertifikasi }}
        <Button
          class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
          @click="$router.go(-1)">Kembali</Button>
      </div>
      <div>
        <CCardBody>
          <CRow>
            <CCol lg="12" class="table-responsive">
              <CDataTable
                style="widht:100% !important"
                :items="items"
                :fields="fields"
                :items-per-page-select='{ label : "Data Per Halaman", class: "float-right" }'
                :tableFilter='{ label:"Pencarian", placeholder:"Cari Data ..", class: "float-left" }'
                hover
                sorter
                :pagination='{ class: "float-right" }'
                :noItemsView="{ noResults: 'Data Mata Uji Peserta tidak ditemukan', noItems: 'Tidak ada data Mata Uji' }"
              >
                <template #no="{ index }">
                  <td class="py-2">{{ (index += 1) }}</td>
                </template>
                <template #nama_mata_uji="{ item }">
                  <td class="py-2">
                    {{ item.nama_mata_uji ? item.nama_mata_uji : "-" }}
                  </td>
                </template>
                <template #nilai="{item}">
                  <td class="py-2">
                  <span v-if="item.nilai">{{ item.nilai }}</span>
                  <span v-else>-</span>
                  </td>
                </template>
                <template #nama_tc="{ item }">
                  <td class="py-2 font-weight-bold">
                    {{ item.nama_tc ? item.nama_tc : "-" }}
                  </td>
                </template>
                <template #tanggal_ujian="{ item }">
                  <td class="py-2 font-weight-bold">
                    {{ item.tanggal_ujian ? item.tanggal_ujian : "-" }}
                  </td>
                </template>
                <template #periode="{ item }">
                  <td class="py-2 font-weight-bold">
                    {{ item.periode ? item.periode : "-" }}
                  </td>
                </template>
                <template #kehadiran="{item}"> 
                    <td
                      class="pl-3 text-bold"
                      style="font-size: 15px"
                      v-if="
                        (item.kehadiran == null &&
                          item.status_refund == null &&
                          item.status_pembatalan == null) ||
                        (item.kehadiran == null &&
                          item.status_refund == null &&
                          item.status_pembatalan == 1)
                      "
                    >
                        <span class="text-warning" v-if="item.status_pembatalan == null">
                            <span v-if="item.status_bayar && item.tanggal_ujian_awal == null">Belum Diikuti</span>
                            <span v-else-if="item.status_bayar && item.tanggal_ujian_awal != null">Reschedule</span>
                            <span v-else-if="item.dat_sertifikasi.invoice.status_pembayaran == 'pending'">Pembayaran Sedang Diproses</span>
                            <span v-else-if="item.status_bayar && item.status_migrasi == 1">Data Migrasi</span>
                            <span v-else>Belum Dibayar</span>
                        </span>
                        <span class="text-info" v-else>

                            Dibatalkan
                        </span>
                    </td>
                    <td
                      class="pl-3 text-bold text-warning"
                      style="font-size: 15px"
                      v-else-if="item.kehadiran == 2"
                    >
                      Sedang Diikuti
                    </td>
                    <!-- &&
                        item.status_refund != 1 &&
                        item.status_pembatalan != 1 -->
                    <td
                      class="pl-3 text-bold text-success"
                      style="font-size: 15px"
                      v-else-if="item.kehadiran == 1"
                    >
                      Diikuti
                    </td>
                    <!-- &&
                        item.status_refund != 1 &&
                        item.status_pembatalan != 1 -->
                    <td
                      class="pl-3 text-bold text-info"
                      style="font-size: 15px"
                      v-else-if="item.status_refund == 0"
                    >
                      Pengajuan Refund
                    </td>
                    <td
                      class="pl-3 text-bold text-info"
                      style="font-size: 15px"
                      v-else-if="item.status_pembatalan == 1"
                    >
                      Dibatalkan
                    </td>
                    <td
                      class="pl-3 text-bold text-info"
                      style="font-size: 15px"
                      v-else-if="item.status_refund == 1"
                    >
                      Dibatalkan
                    </td>
                    <td
                      class="pl-3 text-bold text-danger"
                      style="font-size: 15px"
                      v-else
                    >
                      Ditolak
                    </td>
                </template>
                <template #status_pembayaran="{ item }">
                  <td
                    class="py-2 text-success text-left font-weight-bold"
                    v-if="item.status_pembayaran == 'settlement'"
                  >
                    Lunas
                  </td>
                  <td
                    class="py-2 text-purple text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'pending'"
                  >
                    Menunggu Pembayaran
                  </td>
                  <td
                    class="py-2 text-secondary text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'expired'"
                  >
                    Expired
                  </td>
                  <td
                    class="py-2 text-secondary text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 'failure'"
                  >
                    Pembayaran Gagal
                  </td>
                  <td
                    class="py-2 text-danger text-left font-weight-bold"
                    v-else-if="item.status_pembayaran == 0"
                  >
                    Belum Dibayar
                  </td>
                  <td
                    class="py-2 text-danger text-left font-weight-bold"
                    v-else
                  >
                    Belum Lunas
                  </td>
                </template>
                
                <template #status_pembatalan="{ item }">
                    <td class="py-2 text-left">
                      <p  v-if="item.status_pembatalan == null" class="text-success font-weight-bold"> Sesuai Jadwal </p>
                      <p  v-else-if="item.status_pembatalan != null" class="text-warning font-weight-bold"> Reschedule</p>
                    </td>
                </template>

                <template #status_refund="{ item }">
                  <td class="py-2 text-left">
                    <p  v-if="item.status_refund == null" class="text-info font-weight-bold"> 
                       Tidak Ada Pengajuan
                    </p>
                    <p  v-else-if="item.status_refund == 0" class="text-warning font-weight-bold"> Pengajuan Refund</p>
                    <p  v-else-if="item.status_refund == 1" class="text-success font-weight-bold"> Pengajuan Diterima </p>
                    <p  v-else class="text-danger font-weight-bold"> Pengajuan Ditolak </p>

                  </td>
                </template>

                <template #aksi="{ item }">
                  <td class="py-2 text-center">
                    <CButton
                      v-c-tooltip="'Reschedule'"
                      @click="aksiReschedule(item)"
                      color="success"
                      class="btn-sm"
                      :disabled="item.status_pembatalan == null"
                      square
                    >
                      <font-awesome-icon icon="calendar" class="text-white" />
                    </CButton>
                      <!-- :disabled="item.status_refund == null" -->

                    <CButton
                      v-c-tooltip="'Refund'"
                      @click="aksiRefund(item)"
                      color="warning"
                      class="btn-sm ml-2"
                      :disabled="item.status_refund == null"
                      square>
                      <font-awesome-icon icon="coins" class="text-white" />
                    </CButton>
                  </td>
                </template>                
              </CDataTable>
            </CCol>
          </CRow>
        </CCardBody>
      </div>
    </CCard>
    <!-- End Data Sertifikasi -->

    <ModalPengajuanPembatalanMataUjiSertifikasi
      :modalDetailPembatalan="modalDetailPembatalan"
      :formData="formData"
    />
    
    <!-- Modal Detail User -->
    <CModal
      title="Modal title"
      :show.sync="myModal"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
    >
      <CRow class="px-3">
        <table class="table table-bordered font-weight-bold">
          <tr>
            <th class="bg-primary" style="width: 40%">Nama Mata Uji</th>
            <td>{{ formData.nama_nama_mata_uji }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Tanggal Pendaftaran</th>
            <td>{{ formData.created_at }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Sesi</th>
            <td class="font-weight-bold">{{ formData.sesi }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Nilai</th>
            <td class="font-weight-bold">{{ formData.nilai }}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Status Dokumen</th>
            <td class="text-success">Terverifikasi</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Status Pembayaran</th>
            <td class="" v-if="formData.status_pembayaran == 0">
              Belum Melakukan Pembayaran
            </td>
            <td class="text-success" v-else>
              {{ formData.status_pembayaran }}
            </td>
          </tr>
        </table>
      </CRow>
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail</h6>
      </template>
      <template #footer>
        <CButton @click="myModal = false" color="danger">Tutup</CButton>
      </template>
    </CModal>
    <!-- End Modal -->

    <!-- Modal Reschedule -->
    <CModal
      title="Modal title"
      :show.sync="modalReschedule"
      :no-close-on-backdrop="true"
      :centered="true"
      size="lg"
    >
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail Reschedule</h6>
      </template>      
      <CRow class="px-3">
        <CCard class="w-100">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Nama Test Center</CCardHeader>
          <table class="table font-weight-bold mb-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Test Center</th>
                <th>Tanggal Ujian</th>
                <th>Waktu Ujian</th>
                <th>Sesi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ formData.nama_tc ? formData.nama_tc : '-' }}</td>
                <td>{{ formData.tanggal_ujian ? formData.tanggal_ujian : '-' }}</td>
                <td>{{ formData.waktu ? formData.waktu : '-' }}</td>
                <td>{{ formData.sesi ? formData.sesi : '-' }}</td>
              </tr>
            </tbody>
          </table>
        </CCard>

        <CCard class="w-100 mt-3">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Riwayat Reschedule</CCardHeader>
           <CDataTable 
            style="widht:100% !important" 
            :items="dataRiwayatReschedule" 
            :fields="fieldsRiwayatReschedule"
            hover 
            sorter>
            <template #no="{ index}">
              <td class="py-2">{{ index += 1 }}</td>
            </template>
            
            <template #nama_tc="{item}">
              <td class="py-2 font-weight-bold">{{ item.nama_tc ? item.nama_tc : "-" }}</td>
            </template>
            <template #tanggal_ujian="{item}">
              <td class="py-2 font-weight-bold">{{ item.tanggal_ujian ?  item.tanggal_ujian : "-" }}</td>
            </template>
            <template #waktu="{item}">
              <td class="py-2 font-weight-bold">{{ item.waktu ? item.waktu : "-" }}</td>
            </template>                    
            <template #sesi="{item}">
              <td class="py-2 font-weight-bold">{{ item.sesi ? item.sesi : "-" }}</td>
            </template>                    
          </CDataTable>         
        </CCard>

        <CCard class="w-100 mt-3">
          <CCardHeader class="bg-primary font-weight-bold text-white border-0">Riwayat Test Center</CCardHeader>
          <table class="table font-weight-bold mb-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama Test Center</th>
                <th>Tanggal Ujian</th>
                <th>Waktu Ujian</th>
                <th>Sesi</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>{{ dataRiwayatTestCenter.nama_tc || '-' }}</td>                
                <td>{{ dataRiwayatTestCenter.tanggal_ujian || '-' }}</td>
                <td>{{ dataRiwayatTestCenter.waktu || '-' }}</td>
                <td>{{ dataRiwayatTestCenter.sesi || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </CCard>

      </CRow>      
      <template #footer>
        <CButton @click="modalReschedule = false" color="danger">Tutup</CButton>        
      </template>
    </CModal>
    <!-- End Modal Reschedule -->

    <!-- Modal Refund -->
    <CModal
      title="Modal title"
      :show.sync="modalRefund"
      :no-close-on-backdrop="true"
      :centered="true">

    <CRow>
        <div class="modal-body row my-n3">
            <div class="col-5">
                <p class="font-weight-bold">Kode Pembayaran</p>
                <p class="font-weight-bold">Nama Anggota</p>
                <p class="font-weight-bold">Nama Sertifikasi</p>
                <p class="font-weight-bold">Periode</p>
                <p class="font-weight-bold">Kategori Anggota</p>
                <p class="font-weight-bold">No. Handphone</p>
                <p class="font-weight-bold">No. Telepon</p>
                <p class="font-weight-bold">Email</p>
                <p class="font-weight-bold">Bank</p>
                <p class="font-weight-bold">Nama Rekening</p>
                <p class="font-weight-bold">No. Rekening</p>
                <p class="font-weight-bold">Bukti Refund</p>
                <p class="font-weight-bold">Status Approval Keuangan</p>
                
            </div>
            <div class="col-7">
                <p>: {{ formDataRefund.id_invoice ? formDataRefund.id_invoice : ' - ' }}</p>
                <p>: {{ detailUser.nama_lengkap ? detailUser.nama_lengkap : ' - ' }}</p>
                <p>: {{ detailUser.nama_sertifikasi ? detailUser.nama_sertifikasi : ' - ' }}</p>
                <p>: {{ detailUser.periode ? detailUser.periode : ' - ' }}</p>
                <p>: {{ detailUser.kategori_anggota ? detailUser.kategori_anggota : ' - ' }}</p>
                <p>: {{ detailUser.no_handphone ? detailUser.no_handphone : ' - ' }}</p>
                <p>: {{ detailUser.no_telephone ? detailUser.no_telephone : ' - ' }}</p>
                <p>: {{ detailUser.email ? detailUser.email : ' - ' }}</p>
                <p>: {{ formDataRefund.nama_bank ? formDataRefund.nama_bank : ' - ' }}</p>
                <p>: {{ formDataRefund.nama_rekening ? formDataRefund.nama_rekening : ' - ' }}</p>
                <p>: {{ formDataRefund.no_rekening ? formDataRefund.no_rekening : ' - ' }}</p>
                <p>: <button 
                    :class="formDataRefund.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                    :disabled="formDataRefund.file_bukti_refund === null" 
                    @click="lihatFile(formDataRefund.file_bukti_refund)">
                    Lihat File
                    </button>
                </p>
                <p>: 
                    <span class="text-success font-weight-bold" v-if="formDataRefund.status_approval_keuangan == '1' ">Disetujui</span>
                    <span class="text-danger font-weight-bold" v-else-if="formDataRefund.status_approval_keuangan == '0'">Ditolak</span>
                    <span class="text-warning font-weight-bold" v-else>Menunggu</span>
                  
                </p>
                
            </div>
            <div class="col-12">
                <div class="form-group">
                    <label for="" class="font-weight-bold">Alasan</label>
                    <textarea  
                    class="form-control"
                        cols="30"
                        readonly
                        v-model="formDataRefund.keterangan" 
                        rows="5">
                    </textarea>
                </div>
                <div class="form-group">
                    <label for class="font-weight-bold">Status</label>
                    <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                        <input
                            type="radio"
                            class="custom-control-input"
                            name="customRadio"
                            id="aktif_refund"
                            value="1"
                            :disabled="formDataRefund.status_approval_keuangan == '0' ||  formDataRefund.status_approval_keuangan == null"
                            v-model="formDataRefund.status_pembatalan"                                
                        />
                        <label class="custom-control-label" for="aktif_refund">Disetujui</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                        <input
                            type="radio"
                            class="custom-control-input"
                            name="customRadio"
                            id="tidak_aktif_refund"
                            value="2"
                            :disabled="formDataRefund.status_approval_keuangan == '0' ||  formDataRefund.status_approval_keuangan == null"
                            v-model="formDataRefund.status_pembatalan"                                
                        />
                        <label class="custom-control-label" for="tidak_aktif_refund">Ditolak</label>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </CRow>

      <!-- <CRow class="px-3">
        <table class="table table-bordered font-weight-bold">
          <tr>
            <th class="bg-primary" style="width: 40%">Nama Mata Uji</th>
            <td>{{formData.nama_mata_uji ? formData.nama_mata_uji : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Nama Test Center</th>
            <td>{{formData.nama_tc ? formData.nama_tc : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Tanggal Ujian</th>
            <td>{{formData.tanggal_ujian ? formData.tanggal_ujian : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Nominal</th>
            <td>Rp. {{formData.biaya_per_mata_uji ? formData.biaya_per_mata_uji : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Alasan</th>
            <td>{{formData.keterangan ? formData.keterangan : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Bank</th>
            <td>{{formDataRefund.nama_bank ? formDataRefund.nama_bank : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">No. Rekening</th>
            <td>{{formDataRefund.no_rekening ? formDataRefund.no_rekening : '-'}}</td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Bukti Refund</th>
            <td>
              <button 
                :class="formDataRefund.file_bukti_refund === null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                :disabled="formDataRefund.file_bukti_refund === null" 
                @click="lihatFile(formDataRefund.file_bukti_refund)">
                Lihat File
              </button>
            </td>
          </tr>
          <tr>
            <th class="bg-primary" style="width: 40%">Status</th>
            <td>
              <select name="" class="form-control" id="" v-model="formDataRefund.status_pembatalan">
                <option value="1">Disetujui</option>
                <option value="2">Ditolak</option>
              </select>
            </td>
          </tr>
          
        </table>
      </CRow> -->
      <template #header>
        <h6 class="modal-title h4 font-weight-bold">Detail Refund</h6>
      </template>
      <template #footer>
        <CButton @click="modalRefund = false" color="danger">Tutup</CButton>
        <CButton @click="postStatusRefund" :disabled="formDataRefund.status_approval_keuangan == '0' ||  formDataRefund.status_approval_keuangan == null" type="submit" color="success">Simpan</CButton>
      </template>
    </CModal>
    <!-- End Modal Refund -->
  </div>
</template>

<script>
import DataPesertaService from "@/services/sertifikasi/data-peserta.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import ModalPengajuanPembatalanMataUjiSertifikasi from "@/components/sertifikasi/datapeserta/ModalPengajuanPembatalanMataUjiSertifikasi";
import { fieldsRiwayatReschedule, fields } from "@/const-data/sertifikasi/data-peserta/fields-table" 

import Utils from "@/services/utils.service";

export default {

  name: 'data-peserta-sertifikasi',
  mixins: [AlertUtils],
  
  components: {
    ModalPengajuanPembatalanMataUjiSertifikasi,
  },

  data() {
    return {
      modalDetailPembatalan: false,
      items: [],
      detailUser: {},
      actionPost: "",
      fieldsRiwayatReschedule,
      formDataRefund : {
        id_mata_uji_peserta : '',
        status_pembatalan : '',
        file_bukti_refund : "",
        nama_rekening : "",
        alasan : "",
        no_rekening : "",
        nama_bank : "",
        nama_anggota : "",
        nama_sertifikasi : "",
        kategori_anggota : "",
        no_handphone : "",
        no_telepon : "",
        email : "",
        file_bukti_refund : "",
        alasan : "",
        status_refund : '',
        statusbatal : "",
      },
      formData: {
        id_mata_uji_peserta: "",
        id_sertifikasi_peserta: "",
        id_invoice: "",
        kehadiran: "",
        status_kelulusan: "",
        status_mata_uji: "",
        status_pembatalan: "",
        status_refund: "",
        created_at: "",
        nilai: "",
        status_pembayaran: "",
        nama_mata_uji: "",
        nama_tc: "",
        alamat: "",
        nama_kota_kab: "",
        sesi: "",
        biaya_per_mata_uji: "",
        keterangan: "",
        file_bukti_refund : "",
        nama_rekening : "",
        alasan : "",
        no_rekening : "",
        nama_bank : "",
        nama_anggota : "",
        nama_sertifikasi : "",
        kategori_anggota : "",
        no_handphone : "",
        no_telepon : "",
        email : "",
        statusbatal : "",
      },
      dataRiwayatReschedule: [],
      dataRiwayatTestCenter: [],
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalReschedule: false,
      modalRefund: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
    };
  },
  mounted() {
    this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_peserta);
  },
  methods: {
    postStatusRefund() {
      var loader = this.loaders();
      DataPesertaService.putStatusRefundMataUjiPeserta(this.formDataRefund)
      .then(() => {
        this.modalRefund = false;
        loader.hide();
        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_peserta);
        this.alertSuccess("Berhasil Memperbaharui Status Refund.");
      }).catch(() => {
        loader.hide();
        this.getData(0, 10, this.filter, this.$route.params.id_sertifikasi_peserta);
        this.alertError("Gagal Memperbaharui Status Refund.")
      })
    },

    postStatusPembatalan(formPostPembatalan) {
      if (formPostPembatalan.insertMethod == "reschedule") {
        DataPesertaService.putStatusReschedule(formPostPembatalan)
          .then((res) => {
            // comment console console.log(res);
            this.getData(
              0,
              10,
              this.filter,
              this.$route.params.id_sertifikasi_peserta
            );
          })
          .catch((err) => {
            // comment console console.log(err);
          });
      } else {
      }
    },
  
    aksiReschedule(item) {
      var vm = this;
      this.modalReschedule = true;
      this.formData = item;
      var loaders = this.loaders()      
      DataPesertaService.getDetailReschedule(item.id_mata_uji_peserta)
        .then((response) => {          
          vm.dataRiwayatReschedule = response.data.data;                                          
          vm.dataRiwayatTestCenter = response.data.anotherData
          loaders.hide()
        })
        .catch((error) => {
          // comment console console.log(error);
          loaders.hide()
        });
    },

    aksiRefund(item) {
      this.modalRefund = true;
      // this.formData = item;
      this.formDataRefund = item;
       
      this.formDataRefund.id_mata_uji_peserta = item.id_mata_uji_peserta
      // this.formDataRefund.status_pembatalan = item.status_refund
      this.formDataRefund.file_bukti_refund = item.file_bukti_refund
      this.formDataRefund.nama_rekening = item.nama_rekening
      this.formDataRefund.no_rekening = item.no_rekening
      this.formDataRefund.nama_bank = item.nama_bank
    },

    aksiPembatalan(item) {
      // comment console console.log(this.modalDetailPembatalan);
      if (this.modalDetailPembatalan == true) {
        this.modalDetailPembatalan = false;
      }
      this.lihatDetail(item);
      this.modalDetailPembatalan = true;
    },

    tutupModal() {
      this.modalDetailPembatalan = false;
    }, 

    lihatFile(item) {
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item+"/lokasi/file_refund/bearer/" + token,
        item.file,
        params
      );
    },

    lihatDetail(item) {
      this.formData.id_mata_uji_peserta = item.id_mata_uji_peserta;
      this.formData.id_sertifikasi_peserta = item.id_sertifikasi_peserta;
      this.formData.id_invoice = item.id_invoice;
      this.formData.kehadiran = item.kehadiran;
      this.formData.status_kelulusan = item.status_kelulusan;
      this.formData.status_mata_uji = item.status_mata_uji;
      this.formData.status_pembatalan = item.status_pembatalan;
      this.formData.status_refund = item.status_refund;
      this.formData.created_at = item.created_at;
      this.formData.nilai = item.nilai;
      this.formData.status_pembayaran = item.status_pembayaran;
      this.formData.nama_mata_uji = item.nama_mata_uji;
      this.formData.nama_tc = item.nama_tc;
      this.formData.alamat = item.alamat;
      this.formData.nama_kota_kab = item.nama_kota_kab;
      this.formData.sesi = item.sesi;
      this.formData.file_bukti_refund = item.file_bukti_refund
      this.formData.nama_rekening = item.nama_rekening
      this.formData.alasan = item.alasan
      this.formData.no_rekening = item.no_rekening
      this.formData.nama_bank = item.nama_bank

    },
    
    getData(currentPage, pageSize, filter, idSertifikasiPeserta) {
      var loaders = this.loaders()
      var vm = this;
      DataPesertaService.getMataUjiPesertaSertifikasi(
        currentPage,
        pageSize,
        filter,
        idSertifikasiPeserta
      )
        .then((response) => {          
          this.items = response.data.data;
          this.detailUser = response.data.anotherData;
          loaders.hide();
        })
        .catch((error) => {
          // comment console console.log(error);
          loaders.hide()
        });
    },
    loaders() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      return loader;
    }
  },
  
};
</script>